import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { ChallengesDataService, ChallengesColumnsService } from '../../../services';
import { Challenge, ChallengesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-challenge-details',
  templateUrl: './challenge-details.component.html',
  styleUrls: ['./challenge-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ChallengeDetailsComponent implements OnInit, OnDestroy {

  public challenge: Challenge = {};
  public challenges: Challenge[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private challengesDataService: ChallengesDataService,
    private challengesColumnsService: ChallengesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Challenge - Details');
        this.getChallenge(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.challenge !== 'undefined') {
      this.challenge = this.dynamicDialogConfig.data.challenge;
    }
    this.columns = this.challengesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getChallenge(id: number): void {
    this.isLoading = true;
    this.challengesDataService.getChallenge(id).subscribe((response: Challenge|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.challenge = response;
      }
    });
  }

  list() {
    this.router.navigate(['/challenges']);
  }

  add() {
    this.router.navigate(['/challenges/add']);
  }

  edit() {
    this.router.navigate(['/challenges/edit/' + this.challenge.id]);
  }

}
@Component({
  selector: 'app-challenge-details',
  templateUrl: './challenge-details.component.html',
  styleUrls: ['./challenge-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogChallengeDetailsComponent extends ChallengeDetailsComponent {
}

